<template>
  <v-sheet>
    <div ref="wordcloudContainer" style="min-height: 400px;"></div>
  </v-sheet>
</template>

<script>
import Highcharts from 'highcharts'
import WordCloud from 'highcharts/modules/wordcloud'
WordCloud(Highcharts)

const labelColorMap = {
  GENE: '#2f7ed8',
  PATHWAY: '#8bbc21',
  CELL_LINE: '#910000',
  CHEMICAL: '#1aadce',
  DISEASE: '#492970',
}

export default {
  name: 'WordCloudChart',
  props: {
    tdata: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart:null,
    }
  },
  mounted() {
    const data = this.prepareWordCloudData(this.tdata, 10, 40)
    this.chart = Highcharts.chart(this.$refs.wordcloudContainer, {
      chart: { type: 'wordcloud' },
      title: { text: '' },
      series: [{
        type: 'wordcloud',
        data,
        name: 'Occurrences'
      }],
      tooltip: {
        formatter() {
          return `<b>${this.point.name}</b><br/>
                Count: ${this.point.options.originalWeight}<br/>
                Label: ${this.point.options.label}`
        }
      },
      exporting: { enabled: false }
    })
  },
  methods: {
    prepareWordCloudData(tdata, newMin, newMax) {
      if (!tdata || !tdata.length) return []

      const counts = tdata.map(x => Number(x.count))
      const min = Math.min(...counts)
      const max = Math.max(...counts)

      const normalize = v =>
          ((v - min) / (max - min)) * (newMax - newMin) + newMin

      const mid = (newMin + newMax) / 2

      return tdata.map(item => ({
        name: item.text,
        weight: min === max ? mid : normalize(item.count),
        originalWeight: item.count,
        label: item.label,
        color: labelColorMap[item.label] || '#666'
      }))
    }
  },
  watch: {
    tdata(newVal) {
      if (!this.chart) return
      const data = this.prepareWordCloudData(newVal, 10, 40)
      this.chart.series[0].setData(data, true)
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
}
</script>

